import React from 'react';
import { motion } from 'framer-motion';
import { Rocket as RocketIcon } from 'lucide-react';
const EXTERNAL_URL = 'https://betiqpro.apuestasinteligentes.com/';
interface UserInfo {
  label: string;
  color: string;
  planDetail: string;
}
function getUserInfo(): UserInfo {
  try {
    const stored = localStorage.getItem('betiq_session');
    if (!stored) return {
      label: 'Sin sesión',
      color: 'text-zinc-500',
      planDetail: ''
    };
    const session = JSON.parse(stored);
    if (session.type === 'unlimited') {
      return {
        label: 'Ilimitado',
        color: 'text-blue-400',
        planDetail: 'Acceso completo sin fecha de expiración'
      };
    }
    if (session.type === '5dias') {
      const expiresAt = new Date(session.expiresAt);
      const daysLeft = Math.ceil((expiresAt.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
      const expDate = expiresAt.toLocaleDateString('es-MX', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
      return {
        label: `5 Días Test · ${daysLeft}d restantes`,
        color: 'text-amber-400',
        planDetail: `Expira: ${expDate}`
      };
    }
    return {
      label: 'Desconocido',
      color: 'text-zinc-500',
      planDetail: ''
    };
  } catch {
    return {
      label: 'Sin sesión',
      color: 'text-zinc-500',
      planDetail: ''
    };
  }
}
export function Dashboard() {
  const userInfo = getUserInfo();
  return <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center p-6 text-center selection:bg-blue-500/30" data-id="element-30">
      {/* User badge - top right */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4,
      delay: 0.3
    }} className="fixed top-4 right-4 bg-zinc-900/80 border border-zinc-800 rounded-full px-4 py-2 backdrop-blur-sm" data-id="element-31">
        <span className="text-xs text-zinc-500 font-medium" data-id="element-32">Usuario: </span>
        <span className={`text-xs font-semibold ${userInfo.color}`} data-id="element-33">
          {userInfo.label}
        </span>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="max-w-sm w-full" data-id="element-34">
        {/* Icon */}
        <div className="w-14 h-14 bg-blue-600/20 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(37,99,235,0.15)]" data-id="element-35">
          <div className="w-7 h-7 bg-blue-500 rounded-full shadow-[0_0_15px_rgba(37,99,235,0.5)]" data-id="element-36" />
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-white mb-2 tracking-tight" data-id="element-37">
          Welcome to BetIQ
        </h1>

        {/* Plan info */}
        <div className="mt-3 mb-8" data-id="element-38">
          <div className="inline-flex items-center gap-2 bg-zinc-900/60 border border-zinc-800 rounded-full px-4 py-2" data-id="element-39">
            <span className="text-xs text-zinc-500 font-medium" data-id="element-40">Tu plan:</span>
            <span className={`text-xs font-semibold ${userInfo.color}`} data-id="element-41">
              {userInfo.label}
            </span>
          </div>
          {userInfo.planDetail && <p className="text-zinc-500 text-xs mt-2" data-id="element-42">{userInfo.planDetail}</p>}
        </div>

        {/* CTA Button */}
        <motion.a href={EXTERNAL_URL} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex items-center justify-center gap-2 w-full rounded-xl bg-blue-600 px-4 py-4 text-sm font-semibold text-white transition-all hover:bg-blue-500 active:scale-[0.98] shadow-[0_0_25px_rgba(37,99,235,0.2)] hover:shadow-[0_0_35px_rgba(37,99,235,0.35)]" data-id="element-43">
          <RocketIcon className="w-4 h-4" data-id="element-44" />
          Entrar a BetIQ Pro
        </motion.a>

        <p className="text-zinc-600 text-xs mt-4" data-id="element-45">
          Serás redirigido a betiqpro.apuestasinteligentes.com
        </p>
      </motion.div>
    </div>;
}